import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React from "react";

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
function PopupAlert(props) {
  return (
    <div>
      <Snackbar
        open={props.errorOpen}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={props.handleErrorClose}
        autoHideDuration={props.isSuccessMessage ? 6000 : null}
        style={{
          top: 100,
          position: "fixed",
          zIndex: 999999
        }}
      >
        <Alert
          onClose={props.handleErrorClose}
          severity={!props.isSuccessMessage ? "error" : "success"}
        >
          {props.errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default PopupAlert;
